var map = {
	"./10+Pair+Shoe+Storage+Cabinet+with+Drawer.webp": 21542,
	"./6a67d64eff5587c33ff2d55e1504364c.jpg": 19184,
	"./7eee62ba968b3b84803e7e576ca858e8.jpg": 79587,
	"./e061a027f74a5eacc53244bc31706e14.jpg": 84796,
	"./mian.jpg": 49553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88580;